const presentationDefaultState = {
  currentUser: {},
  slides: [],
  idSlide: null,
  logo: null,
  presentation: {},
  showQaSession: false,
  questions: [],
  tabQnaQuestion: 1,
  questionerName: '',
  questionCount: 0,
  userLoaded: null,
  socketDisconnect: false,
  connectionError: false,
  disableScrollBody: false,
  showRequestPresentation: false,
  voiceCall: {}, // opentok video call
  authenticationCode: '',
  currentDataNextSlide: null, // handle correct next slide
  activeTabView: 'slide', // ['slide', 'lookback', 'feedback', profile]
  isLoadingCurrentUser: false,
  tsRequest: null, // timestamp request leaderboard
}

export default presentationDefaultState
